import { useTranslation } from "@/shared/providers/LanguageProvider";
import { useSidebar } from "@/modules/dashboard-shell/SidebarProvider";
import { NavLink } from "./NavLink";

type NavSectionBlockProps = {
  section: NavSection;
};

export function NavSectionBlock({ section }: NavSectionBlockProps) {
  const { t } = useTranslation();
  const { isOpen } = useSidebar();

  return (
    <div>
      {section.titleKey &&
        (isOpen ? (
          <p className="mb-2 px-3 text-[10px] font-bold uppercase tracking-[0.14em] text-sidebar-muted">
            {t.safecheck.nav[section.titleKey as SafecheckNavKey]}
          </p>
        ) : (
          // Menu replié : un simple filet sépare les sections.
          <div className="mx-auto mb-3 h-px w-6 bg-sidebar-border" aria-hidden="true" />
        ))}
      <nav className="space-y-1">
        {section.items.map((item) => (
          <NavLink key={item.id} item={item} />
        ))}
      </nav>
    </div>
  );
}
